const r = (s) => {
  const e = {}, n = Object.entries(s);
  for (const t of n)
    e[t[1]] = t[0];
  return e;
};
export {
  r as swapKeysAndValues
};
//# sourceMappingURL=object.mjs.map
